import { Injectable } from '@angular/core';

@Injectable()
export class FileHelperService {

    constructor(
    ) { }

    /**
     * parse the given file and execute the callback after the file is read
     * @param file the file to extract
     * @param callback the callback to execute (eg. (data) => { this.file.data = data ;})
     */
    fileToDataUrl(file: any, callback): any {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = (e) => {
            callback(fileReader.result);
        };
    }

    /**
     * open the brorwsers donwload dialog to download the given data
     * @param name the target name of the file
     * @param data the base64 encoded dataUrl
     */
    downloadDataUrl(name: string, data: string) {
        this.downloadData(name, this.dataToObjectUrl(data));
    }

    /**
     * transforms the content dataUrl to a downloadable file
     * generates a new File and returns this file as ObjectUrl
     * @param data the base64 encoded dataUrl
     */
    private dataToObjectUrl(data: string) {
        const arr = data.split(',');
        const mimeType = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        const file = new File([u8arr], name, { type: mimeType });
        const url = window.URL.createObjectURL(file);
        return url;
    }

    /**
     * opens the saveFile dialog with the given objectUrl
     * @param name the target name of the file
     * @param objectUrl the content of the file
     */
    private downloadData(name: string, objectUrl: string, ) {
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.href = objectUrl;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(objectUrl);
    }
}
